import { render } from "./AboutCompanyComponentNext.vue?vue&type=template&id=42403454"
import script from "./AboutCompanyComponentNext.vue?vue&type=script&lang=js"
export * from "./AboutCompanyComponentNext.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__